import { jsxs as h, jsx as d } from "react/jsx-runtime";
import { c, I as x } from "./Section-DOeCOW54.js";
import p, { createElement as k, useState as y, useEffect as f } from "react";
const B = "elo-tablet", N = "elo-mobile", S = {
  "text__label--large": "elo-text__label--large",
  "text__paragraph--large": "elo-text__paragraph--large",
  "text__span--large": "elo-text__span--large",
  "text__label--medium": "elo-text__label--medium",
  "text__paragraph--medium": "elo-text__paragraph--medium",
  "text__span--medium": "elo-text__span--medium",
  "text__label--mediumBold": "elo-text__label--mediumBold",
  "text__paragraph--mediumBold": "elo-text__paragraph--mediumBold",
  "text__span--mediumBold": "elo-text__span--mediumBold",
  "text__label--small": "elo-text__label--small",
  "text__paragraph--small": "elo-text__paragraph--small",
  "text__span--small": "elo-text__span--small",
  "text__label--xsmall": "elo-text__label--xsmall",
  "text__paragraph--xsmall": "elo-text__paragraph--xsmall",
  "text__span--xsmall": "elo-text__span--xsmall",
  "text__display--large": "elo-text__display--large",
  tablet: B,
  mobile: N,
  "text__display--medium": "elo-text__display--medium",
  "text__display--small": "elo-text__display--small",
  "text__heading--large": "elo-text__heading--large",
  "text__heading--medium": "elo-text__heading--medium",
  "text__heading--small": "elo-text__heading--small",
  "text__heading--xsmall": "elo-text__heading--xsmall"
}, T = {
  display: {
    large: "h1",
    medium: "h2",
    small: "h2",
    mediumBold: "h2",
    xsmall: "h2"
  },
  heading: {
    large: "h1",
    medium: "h2",
    small: "h3",
    mediumBold: "h3",
    xsmall: "h4"
  },
  label: {
    large: "span",
    medium: "span",
    mediumBold: "span",
    small: "span",
    xsmall: "span"
  },
  paragraph: {
    large: "p",
    medium: "p",
    mediumBold: "p",
    small: "p",
    xsmall: "p"
  },
  span: {
    large: "span",
    medium: "span",
    mediumBold: "span",
    small: "span",
    xsmall: "span"
  }
}, b = p.forwardRef(
  ({ type: e, size: s, children: t, extraClass: l, lang: i, ...a }, r) => {
    var g;
    const m = `text__${e}--${s}`, _ = c(
      [S[m] ?? ""],
      l
    ), u = ((g = T[e]) == null ? void 0 : g[s]) || "span";
    return k(u, { className: _, ref: r, lang: i, ...a }, t);
  }
), C = "elo-button", n = {
  button: C,
  "button__ghost-text-underline": "elo-button__ghost-text-underline",
  "button__ghost-text-underline--dark": "elo-button__ghost-text-underline--dark",
  "button--large": "elo-button--large",
  "button--primary": "elo-button--primary",
  "button--secondary": "elo-button--secondary",
  "button--ghost": "elo-button--ghost",
  "button--disabled": "elo-button--disabled",
  "button--dark--primary": "elo-button--dark--primary",
  "button--dark--secondary": "elo-button--dark--secondary",
  "button--dark--ghost": "elo-button--dark--ghost",
  "button--dark--disabled": "elo-button--dark--disabled"
}, $ = p.forwardRef(
  ({
    dark: e = !1,
    small: s = !0,
    variant: t = "primary",
    iconLeft: l,
    iconRight: i,
    children: a,
    ...r
  }, m) => {
    const _ = c(n.button, r.className, {
      [n["button--large"]]: !s,
      [n["button--primary"]]: t === "primary",
      [n["button--secondary"]]: t === "secondary",
      [n["button--ghost"]]: t === "ghost",
      [n["button--dark--primary"]]: t === "primary" && e,
      [n["button--dark--secondary"]]: t === "secondary" && e,
      [n["button--dark--ghost"]]: t === "ghost" && e,
      [n["button--dark--disabled"]]: r.disabled
    }), u = c(
      t === "ghost" && !e && n["button__ghost-text-underline"],
      t === "ghost" && e && n["button__ghost-text-underline--dark"]
    );
    return /* @__PURE__ */ h("button", { ...r, ref: m, className: _, children: [
      l && /* @__PURE__ */ d(x, { name: l }),
      /* @__PURE__ */ d(
        b,
        {
          type: "span",
          size: s ? "small" : "medium",
          extraClass: u,
          children: a
        }
      ),
      i && /* @__PURE__ */ d(x, { name: i })
    ] });
  }
), o = {
  "icon-link": "elo-icon-link",
  "icon-link__ghost-text-underline": "elo-icon-link__ghost-text-underline",
  "icon-link__ghost-text-underline--dark": "elo-icon-link__ghost-text-underline--dark",
  "icon-link--large": "elo-icon-link--large",
  "icon-link--primary": "elo-icon-link--primary",
  "icon-link--secondary": "elo-icon-link--secondary",
  "icon-link--ghost": "elo-icon-link--ghost",
  "icon-link--disabled": "elo-icon-link--disabled",
  "icon-link--dark--primary": "elo-icon-link--dark--primary",
  "icon-link--dark--secondary": "elo-icon-link--dark--secondary",
  "icon-link--dark--ghost": "elo-icon-link--dark--ghost",
  "icon-link--dark--disabled": "elo-icon-link--dark--disabled"
}, w = p.forwardRef(
  ({
    variant: e = "primary",
    small: s = !0,
    iconLeft: t,
    iconRight: l,
    children: i,
    dark: a = !1,
    ...r
  }, m) => {
    const _ = c(o["icon-link"], r.className, {
      [o["icon-link--large"]]: !s,
      [o["icon-link--primary"]]: e === "primary",
      [o["icon-link--secondary"]]: e === "secondary",
      [o["icon-link--ghost"]]: e === "ghost",
      [o["icon-link--disabled"]]: r.disabled,
      [o["icon-link--dark--primary"]]: e === "primary" && a,
      [o["icon-link--dark--secondary"]]: e === "secondary" && a,
      [o["icon-link--dark--ghost"]]: e === "ghost" && a
    }), u = c(
      e === "ghost" && !a && o["icon-link__ghost-text-underline"],
      e === "ghost" && a && o["icon-link__ghost-text-underline--dark"]
    );
    return /* @__PURE__ */ h("a", { ...r, ref: m, className: _, children: [
      t && /* @__PURE__ */ d(x, { name: t }),
      /* @__PURE__ */ d(
        b,
        {
          type: "span",
          size: s ? "small" : "medium",
          extraClass: u,
          children: i
        }
      ),
      l && /* @__PURE__ */ d(x, { name: l })
    ] });
  }
), j = (e) => {
  const [s, t] = y(() => !1);
  return f(() => {
    const l = matchMedia(e);
    t(l.matches);
    const i = (a) => t(a.matches);
    return l.addEventListener("change", i), () => l.removeEventListener("change", i);
  }, [e]), s;
};
export {
  $ as B,
  w as I,
  b as T,
  j as u
};
